import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';

const redirectHosts: Record<string, string> = {
  'condor.dev.aviarysystems.com':
    'https://condor.vpn.platform-prod.donut.systems',
  'condor.prod.aviarysystems.com':
    'https://condor.vpn.platform-prod.donut.systems',
};
const redirectHost = redirectHosts[window.location.hostname];

if (redirectHost) {
  window.condorRedirectPending = true;
  const target =
    window.location.pathname === '/login/callback'
      ? `${redirectHost}/`
      : `${redirectHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(target);
}

// App is loaded lazily because importing it constructs the Okta client.
if (!window.condorRedirectPending) {
  import('./App').then(({ default: App }) => {
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement,
    );
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
}
